// extracted by mini-css-extract-plugin
module.exports = {"AvtaleListe":"AvtaleListe_AvtaleListe__2IALS","oppdatert":"AvtaleListe_oppdatert__2P-LO","EmptyList":"AvtaleListe_EmptyList__2uCMl"};